<template>
  <Modal v-model="ymsOrderSyncRulesModal" :title="ymsOrderSyncRulesTitle" width="550" :transfer="false"
    :mask-closable="false" @on-visible-change="ymsOrderSyncRulesChange">
    <Form ref="ymsOrderSyncRulesForm" :model="ymsOrderSyncRulesForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 95%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005351')" prop="platformIds">
            <Select v-model="ymsOrderSyncRulesForm.platformIds" multiple filterable transfer :placeholder="$t('key1005631')">
              <Option v-for="item in allPlatformList" :value="item.platformId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="`${configCharacters()}` + $t('key1005617')" prop="timer" :label-width="110">
            <div class="flex align-items-center">
              <InputNumber :max="999" :min="24" v-model="ymsOrderSyncRulesForm.timer"
                :formatter="value => `${parseInt(value)}`" :active-change="false" style="width: 120px;margin-left: 4px;">
              </InputNumber>
              <span class="font-size-13 ml4">{{ $t('key1005618') + configCharacters() + $t('key1001887') }}</span>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001522')" :label-width="68" prop="status" class="radio_styles_distributor">
            <RadioGroup v-model="ymsOrderSyncRulesForm.status">
              <Radio :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="0">{{ $t('key1000463') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="ymsOrderSyncRulesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="ymsOrderSyncRulesBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {setConfigCharacters} from "@/utils/common";

export default {
  name: "ymsOrderSyncRulesModal",
  mixins: [Mixin],
  props: {
    platformList: { // 适用平台
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      ymsOrderSyncRulesModal: false,
      ymsOrderSyncRulesTitle: '',
      ymsOrderSyncRulesForm: {
        platformIds: [],
        timer: null,
        status: 1
      },
      ruleValidate: {
        platformIds: [
          {type: 'array', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005631'), trigger: 'change'},
        ],
        timer: [
          {type: 'number', required: true, message: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005647')}`, trigger: 'change'}
        ]
      },
      autoRuleId: null,
      ruleType: null,
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    allPlatformList() {
      let platformList = JSON.parse(JSON.stringify(this.platformList));
      return platformList.concat([{platformId: 'other', name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005449')}`}]);
    }
  },
  methods: {
    // 初始化数据
    initYmsOrderSyncRulesData(type, autoRuleId) {
      let obj = {
        add: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000718')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005613')}`,
        edit: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003503')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005613')}`
      };
      this.ruleType = type;
      this.ymsOrderSyncRulesTitle = obj[type];
      if (type === 'edit') {
        this.getymsOrderSyncRulesData(autoRuleId);
      } else {
        this.ymsOrderSyncRulesModal = true;
      }
    },
    // 获取规则详情数据
    getymsOrderSyncRulesData(autoRuleId) {
      let v = this;
      v.axios.get(api.get_ymsPackageInfoSynRule + autoRuleId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.autoRuleId = data.autoRuleId;
            v.ymsOrderSyncRulesForm.status = data.status;
            let ruleActions = data.ruleActions || [];
            let ruleItems = data.ruleItems || [];
            if (ruleActions.length > 0) {
              ruleActions.map((ele) => {
                if (ele.type === 'YMS_CORE_PACKAGE_CANCEL_RULE') {
                  let obj = JSON.parse(ele.value);
                  v.ymsOrderSyncRulesForm.platformIds = obj.platformId ? [obj.platformId] : [];
                }
              });
            }
            if (ruleItems.length > 0) {
              ruleItems.map((talg) => {
                let ruleItemParams = talg.ruleItemParams || [];
                if (ruleItemParams.length > 0) {
                  ruleItemParams.map((k) => {
                    if (k.name === 'boxedTimeOut') {
                      let ruleItemParamValues = k.ruleItemParamValues || [];
                      if (ruleItemParamValues.length > 0) {
                        ruleItemParamValues.map((j) => {
                          if (j.autoRuleItemParamId === k.autoRuleItemParamId) {
                            v.ymsOrderSyncRulesForm.timer = Number(j.value) || null;
                          }
                        });
                      }
                    }
                  });
                }
              });
            }
            v.ymsOrderSyncRulesModal = true;
          }
        }
      });
    },
    // 保存按钮
    ymsOrderSyncRulesBtn() {
      let v = this;
      let query = {};
      let url = '';
      let method = '';
      let text = '';
      query = {
        autoRuleActions: [
          {
            type: 'YMS_CORE_PACKAGE_CANCEL_RULE',
            value: JSON.stringify({platformIds: v.ymsOrderSyncRulesForm.platformIds})
          }
        ],
        autoRuleItems: [{
          autoRuleParams: [{
            autoRuleParamValues: [{
              value: v.ymsOrderSyncRulesForm.timer
            }],
            name: 'boxedTimeOut'
          }]
        }],
        businessId: v.userInfo.merchantId, // 落到商户级别
        name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005648')}`,
        status: v.ymsOrderSyncRulesForm.status
      };
      if (v.ruleType === 'add') {
        url = api.post_ymsPackageInfoSynRule_insert;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113');
      } else {
        url = api.put_ymsPackageInfoSynRule_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161');
        query.autoRuleId = v.autoRuleId;
      }
      v.$refs['ymsOrderSyncRulesForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.ymsOrderSyncRulesModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    ymsOrderSyncRulesChange(value) {
      if (!value) {
        this.$refs['ymsOrderSyncRulesForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-form-item-label, label {
  font-size: 13px !important;
}
</style>